export default __webpack_public_path__ + "static/media/headphone.07072fde.svg";